import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCz = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 900 600", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 900, height: 600, fill: "#d7141a" }), /* @__PURE__ */ React.createElement("rect", { width: 900, height: 300, fill: "#fff" }), /* @__PURE__ */ React.createElement("path", { d: "M 450,300 0,0 V 600 z", fill: "#11457e" }));
const ForwardRef = forwardRef(SvgCz);
const Memo = memo(ForwardRef);
export default Memo;
